module.exports = __webpack_public_path__ + "static/blog-59c31e3e2270f1dc68c8327cca69f5cc.png";